import { render, staticRenderFns } from "./PedidoItemDetalle.vue?vue&type=template&id=7ab5697c&scoped=true"
import script from "./PedidoItemDetalle.vue?vue&type=script&lang=js"
export * from "./PedidoItemDetalle.vue?vue&type=script&lang=js"
import style0 from "./PedidoItemDetalle.vue?vue&type=style&index=0&id=7ab5697c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ab5697c",
  null
  
)

export default component.exports